import { Box, Text } from '@factorialco/deprecated-design-system'

import type { FeatureItem as FeatureItemType } from '../../_Content/countryContent'

interface FeatureItemProps {
  feature: FeatureItemType
}

const FeatureItem = ({ feature }: FeatureItemProps) => {
  return (
    <Box gap="s8" alignItems="center" className="flex-1">
      <Text color="black" size="400" weight="bold">
        {feature.title}
      </Text>
      <Box maxWidth="s360">
        <Text size="300">{feature.subtitle}</Text>
      </Box>
    </Box>
  )
}

export default FeatureItem
